<template>
  <transition name="zoom-in-top">
    <div class="e6-box-layor" v-show="isShowBox" :style="{ width: width }">
      <div class="e6-box-top" v-drag>
        <span>{{ title }}</span>
        <i class="e6-icon-delete_line" title="关闭" @click="closeBox"></i>
      </div>
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: "e6Box",
  props: {
    title: {
      type: String,
      default: "e6Box"
    },
    isShowBox: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "auto"
    }
  },
  directives: {
    drag(el) {
      let winH = document.documentElement.clientHeight;
      let winW = document.documentElement.clientWidth;
      var wh = {
        windowHeight: winH,
        windowWidth: winW
      };
      el.onmousedown = function(e) {
        // var boxW = el.parentElement.offsetWidth;
        var disx = e.pageX - el.parentElement.offsetLeft;
        var disy = e.pageY - el.parentElement.offsetTop;
        var h = el.parentElement.offsetHeight;
        var w = el.parentElement.offsetWidth;
        document.onmousemove = function(e) {
          var movex = e.pageX - disx;
          var movey = e.pageY - disy;
          movex =
            movex < 0
              ? 0
              : movex + w > wh.windowWidth
              ? wh.windowWidth - w
              : movex;
          movey =
            movey < 0
              ? 0
              : movey + h > wh.windowHeight
              ? wh.windowHeight - h
              : movey;
          el.parentElement.style.left = movex + "px";
          el.parentElement.style.top = movey + "px";
        };
        document.onmouseup = function() {
          document.onmouseup = document.onmousemove = null;
        };
        e.preventDefault();
      };
    }
  },
  methods: {
    closeBox() {
      this.$emit("update:isShowBox", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.e6-box-layor {
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  position: absolute;
  background-color: #fff;
  z-index: 200;
  min-width: 200px;
  box-sizing: border-box;
  .e6-box-top {
    cursor: move;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 3px 3px 0 0 !important;
    background: #f8f8f8 !important;
    color: #303133;
    font-size: 12px;
    height: 35px;
    line-height: 35px;
    padding: 0 10px;
    i {
      cursor: pointer;
    }
  }
}
$--md-fade-transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
  opacity 300ms cubic-bezier(0.23, 1, 0.32, 1) !default;
.zoom-in-top-enter-active,
.zoom-in-top-leave-active {
  opacity: 1;
  transform: scaleY(1);
  transition: $--md-fade-transition;
  transform-origin: center top;
}
.zoom-in-top-enter,
.zoom-in-top-leave-active {
  opacity: 0;
  transform: scaleY(0);
}
</style>
